import GeneratedFileServiceApi from "./generated/GeneratedFileServiceApi"

class FileServiceApi extends GeneratedFileServiceApi {

}

export const fileServiceApi = new FileServiceApi()
